<main class="mediumContainer">
    <mat-card>
        <mat-card-header>
            <mat-card-subtitle>
                <h3>Reports</h3>
            </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content [formGroup]="form">
            <app-custom-toggle-group [options]="modeOptions" formControlName="mode"></app-custom-toggle-group>
            <ng-container
                    *ngIf="selectedManageMode === managementMode.Generate || selectedManageMode === managementMode.BI">
                <mat-form-field class="w-100" color="accent">
                    <mat-label>Report type</mat-label>
                    <mat-select [formControl]="reportType">
                        <mat-option *ngFor="let type of reportTypes" [value]="type.type">{{ type.label }}</mat-option>
                    </mat-select>
                    <mat-error *ngIf="reportType.hasError('required')">
                        This field is required
                    </mat-error>
                </mat-form-field>

                <mat-form-field *ngIf="reportControlIds.includes('communityId')" class="w-100" color="accent">
                    <mat-label>Community</mat-label>
                    <mat-select formControlName="communityId">
                        <mat-option *ngIf="selectedManageMode === managementMode.Generate" value="">All</mat-option>
                        <mat-option *ngFor="let community of communities" [value]="community.id">{{ community.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="form.controls['communityId'].hasError('required')">
                        This field is required
                    </mat-error>
                </mat-form-field>

                <mat-form-field *ngIf="reportControlIds.includes('subgroupId')" class="w-100" color="accent">
                    <mat-label>Subgroup</mat-label>
                    <mat-select formControlName="subgroupId">
                        <mat-option *ngIf="!subgroups.length && selectedCommunityId" disabled value="">Current community
                            has no subgroups
                        </mat-option>
                        <mat-option *ngIf="!!subgroups.length" value="">All</mat-option>
                        <mat-option *ngFor="let subgroup of subgroups" [value]="subgroup.id">{{ subgroup.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="form.controls['subgroupId'].hasError('required')">
                        This field is required
                    </mat-error>
                </mat-form-field>

                <mat-form-field *ngIf="reportControlIds.includes('postId')" class="w-100 mb-15" color="accent">
                    <mat-label>Post</mat-label>
                    <mat-select formControlName="postId">
                        <mat-option *ngIf="!posts.length && selectedCommunityId" disabled value="">Current community has
                            no posts
                        </mat-option>
                        <mat-option *ngIf="!!posts.length" value="">All</mat-option>
                        <mat-option *ngFor="let post of posts" [value]="post.id">[ID:{{ post.id }}] - {{ post.title }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="form.controls['postId'].hasError('required')">
                        This field is required
                    </mat-error>
                    <mat-hint>Reports for individual posts are limited to the last 200</mat-hint>
                </mat-form-field>

                <mat-form-field *ngIf="reportControlIds.includes('memberId')" class="w-100 mb-15" color="accent">
                    <mat-label>Member</mat-label>
                    <mat-select formControlName="memberId">
                        <mat-option *ngIf="!users.length && selectedCommunityId" disabled value="">Current community has
                            no members
                        </mat-option>
                        <mat-option *ngIf="!!users.length" value="">All</mat-option>
                        <mat-option *ngFor="let user of users" [value]="user.id">{{ userName(user) }}</mat-option>
                    </mat-select>
                    <mat-error *ngIf="form.controls['memberId'].hasError('required')">
                        This field is required
                    </mat-error>
                </mat-form-field>

                <mat-form-field *ngIf="reportControlIds.includes('pollId')" class="w-100 mb-15" color="accent">
                    <mat-label>Poll</mat-label>
                    <mat-select formControlName="pollId">
                        <mat-option *ngIf="!polls.length && selectedCommunityId" disabled value="">No polls available
                        </mat-option>
                        <mat-option *ngIf="!!polls.length" value="">All</mat-option>
                        <mat-option *ngFor="let poll of polls" [value]="poll.id">[ID: {{ poll.id }}] - {{ poll.text }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="form.controls['pollId'].hasError('required')">
                        This field is required
                    </mat-error>
                </mat-form-field>

                <mat-form-field *ngIf="reportControlIds.includes('segmentId')" class="w-100" color="accent">
                    <mat-label>Segment</mat-label>
                    <mat-select formControlName="segmentId">
                        <mat-option *ngIf="!segments.length && selectedCommunityId" disabled value="">No segments
                            available
                        </mat-option>
                        <mat-option *ngIf="!!segments.length" value="">All</mat-option>
                        <mat-option *ngFor="let segment of segments" [value]="segment.id">{{ segment.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="form.controls['segmentId'].hasError('required')">
                        This field is required
                    </mat-error>
                    <mat-icon *ngIf="segmentLoading" matSuffix>
                        <mat-spinner color="accent"></mat-spinner>
                    </mat-icon>
                </mat-form-field>

                <mat-form-field *ngIf="reportControlIds.includes('activityType')" class="w-100" color="accent">
                    <mat-label>Activity type</mat-label>
                    <mat-select formControlName="activityType">
                        <mat-option value="">All</mat-option>
                        <mat-option *ngFor="let activityType of activityTypes"
                                    [value]="activityType.value">{{ activityType.label }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="form.controls['activityType'].hasError('required')">
                        This field is required
                    </mat-error>
                </mat-form-field>

                <mat-form-field *ngIf="reportControlIds.includes('startDate') && reportControlIds.includes('endDate')"
                                class="w-100"
                                color="accent">
                    <mat-label>Enter a date range</mat-label>
                    <mat-date-range-input [rangePicker]="picker">
                        <input class="w-100" formControlName="startDate" matStartDate placeholder="Start date">
                        <input formControlName="endDate" matEndDate placeholder="End date">
                    </mat-date-range-input>
                    <mat-datepicker-toggle (click)="clearDate()" *ngIf="dateSet" matIconSuffix>
                        <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                    </mat-datepicker-toggle>
                    <mat-datepicker-toggle [for]="picker" matIconSuffix></mat-datepicker-toggle>
                    <mat-date-range-picker #picker color="accent"></mat-date-range-picker>

                    <mat-error *ngIf="form.controls['startDate'].hasError('matStartDateInvalid')">Invalid start date
                    </mat-error>
                    <mat-error *ngIf="form.controls['endDate'].hasError('matEndDateInvalid')">Invalid end date
                    </mat-error>
                    <mat-error
                            *ngIf="form.controls['startDate'].hasError('required')||form.controls['endDate'].hasError('required')">
                        This field is required
                    </mat-error>
                </mat-form-field>
            </ng-container>
            <ng-container *ngIf="selectedManageMode === managementMode.Exist">
                <mat-form-field class="w-100" color="accent">
                    <mat-label>Community</mat-label>
                    <mat-select [(ngModel)]="communitiesFilter"
                                (ngModelChange)="reloadContent(false)"
                                [ngModelOptions]="{standalone: true}">
                        <mat-option value="">All</mat-option>
                        <mat-option *ngFor="let community of communities" [value]="community.id">{{ community.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <ng-container [ngTemplateOutlet]="statistics"></ng-container>
            </ng-container>
            <ng-container *ngIf="selectedManageMode === managementMode.Pending">
                <p *ngIf="pendingReports.data.length <= 0">There are no reports currently being generated</p>
                <table *ngIf="pendingReports.data.length > 0" [dataSource]="pendingReports" class="responsiveTable"
                       mat-table>
                    <ng-container matColumnDef="task_name">
                        <th *matHeaderCellDef mat-header-cell>Name</th>
                        <td *matCellDef="let row" mat-cell>
                            <b class="d-none columnTitle">Name:</b> {{ row.task_name }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="date_created">
                        <th *matHeaderCellDef mat-header-cell>Created At</th>
                        <td *matCellDef="let row" mat-cell><b class="d-none columnTitle">Created
                            At:</b> {{ row.date_created | date }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="status">
                        <th *matHeaderCellDef mat-header-cell>Status</th>
                        <td *matCellDef="let row" mat-cell><b
                                class="d-none columnTitle">Status:</b> {{ row.status }}
                        </td>
                    </ng-container>
                    <tr *matHeaderRowDef="displayColumns" mat-header-row></tr>
                    <tr *matRowDef="let row; columns: displayColumns;" mat-row></tr>
                    <tr *matNoDataRow class="mat-row">
                        <td class="mat-cell text-center"
                            colspan="3"> There are no reports currently being generated
                        </td>
                    </tr>
                </table>
            </ng-container>
        </mat-card-content>

        <mat-card-footer>
            <mat-card-actions class="text-center mt-10">
                <button (click)="loadMore()" *ngIf="allowLoadMore && selectedManageMode === managementMode.Exist"
                        class="mx-auto" color="accent" mat-raised-button>
                    Load more
                </button>
                <button (click)="generate()" *ngIf="selectedManageMode == managementMode.Generate"
                        [disabled]="form.invalid || loading"
                        class="mx-auto"
                        color="accent" mat-flat-button>
                    Generate report
                    <mat-icon *ngIf="loading">
                        <mat-spinner color="accent"></mat-spinner>
                    </mat-icon>
                </button>
                <button (click)="generate(true)" *ngIf="selectedManageMode == managementMode.BI"
                        [disabled]="form.invalid || loading"
                        class="mx-auto"
                        color="accent" mat-flat-button>
                    Generate Power Bi Url
                    <mat-icon *ngIf="loading">
                        <mat-spinner color="accent"></mat-spinner>
                    </mat-icon>
                </button>
            </mat-card-actions>
        </mat-card-footer>
    </mat-card>
</main>


<ng-template #statistics>
    <mat-accordion class="statistics-accordion">
        <mat-expansion-panel *ngFor="let statSet of filteredCombinedStatistics">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    {{ statSet.title }}
                </mat-panel-title>
                <ng-container *ngIf="statSet.community_id && getCommunityFromId(statSet.community_id) !='' ">
                    <mat-panel-description
                            *ngIf="!statSet.title.includes(getCommunityFromId(statSet.community_id))">
                        For {{ getCommunityFromId(statSet.community_id) }}
                    </mat-panel-description>
                </ng-container>
            </mat-expansion-panel-header>
            <div *ngIf="statSet.statistics" class="chart">
                <div *ngFor="let stat of statSet.statistics" [class.py-15]="stat.skip" class="chart-bar">
                    <div class="chart-bar-total">
                        <span class="z-index-2">{{ stat.total | number }}</span>
                        <div *ngIf="stat.new" [style.width.%]="calculateNewPercentage(stat.new, stat.total)"
                             class="chart-bar-new">
                            +{{ stat.new | number }}
                        </div>
                    </div>
                    <div class="chart-bar-label">{{ stat.label }}</div>
                </div>
            </div>
            <div *ngIf="statSet.fileUrl" class="chart">
                <div class="chart-bar">
                    <div class="chart-bar-label">
                        {{ statSet.title }} successfully generated. You can download it by clicking the button below.
                    </div>
                </div>
            </div>
            <div class="expansion-actions">
                <!--                <div *ngIf="statSet.type === 'Engagement'"-->
                <!--                     [matTooltipDisabled]="allowGeneratePowerBi(statSet) || powerBiTokens.has(statSet.id)"-->
                <!--                     matTooltip="PowerBi token generation disabled for reports featuring all communities">-->
                <!--                    <button-->
                <!--                            (click)="generatePowerBi(statSet)"-->
                <!--                            [disabled]="!allowGeneratePowerBi(statSet)"-->
                <!--                            class=""-->
                <!--                            color="accent"-->
                <!--                            mat-raised-button>-->
                <!--                        Generate PowerBi token-->
                <!--                        <mat-icon *ngIf="loadingPowerBi">-->
                <!--                            <mat-spinner color="accent"></mat-spinner>-->
                <!--                        </mat-icon>-->
                <!--                    </button>-->
                <!--                </div>-->
                <div *ngIf="statSet.fileUrl">
                    <button
                            (click)="downloadFile(statSet)"
                            class=""
                            color="accent"
                            mat-raised-button>
                        Download file
                        <mat-icon *ngIf="loadingPowerBi">
                            <mat-spinner color="accent"></mat-spinner>
                        </mat-icon>
                    </button>
                </div>
            </div>
            <div *ngIf="powerBiTokens.has(statSet.id)" class="expansion-powerbi-info mt-20">
                <small>The first report may some time to generate after creating a PowerBI URL</small>
                <div class="flex-row gap-5 mb-10 align-items-center">
                    <div [style.flex]="2">Url:</div>
                    <mat-form-field [style.flex]="15" class="w-100 noBottomPadding">
                        <input #url [value]="powerBiTokens.get(statSet.id)?.url" matInput readonly>
                    </mat-form-field>
                    <button [cdkCopyToClipboard]="url.value" [style.flex]="1" mat-icon-button matTooltip="Copy">
                        <mat-icon>content_copy</mat-icon>
                    </button>
                </div>
                <div class="flex-row gap-5 align-items-center">
                    <div [style.flex]="2">Token:</div>
                    <mat-form-field [style.flex]="15" class="w-100 noBottomPadding">
                        <input #token [value]="powerBiTokens.get(statSet.id)?.token" matInput readonly>
                    </mat-form-field>
                    <button [cdkCopyToClipboard]="token.value" [style.flex]="1" mat-icon-button matTooltip="Copy">
                        <mat-icon>content_copy</mat-icon>
                    </button>
                </div>
                <div class="mt-20 flex-row align-items-center gap-25">
                    <mat-icon color="accent">priority_high</mat-icon>
                    {{ powerBiTokens.get(statSet.id)?.description }}
                </div>
            </div>
        </mat-expansion-panel>
    </mat-accordion>
</ng-template>
